import {capitalize} from '@mui/material';

export function formatToCapitalizeWithExceptions(
	text: string | null | undefined,
	exceptions: string[] = [],
): string {
	if (!text || typeof text !== 'string') {
		return '';
	}

	let formatted = text.trim().toLowerCase();

	if (formatted.length > 0) {
		formatted = capitalize(formatted);
	}

	exceptions.forEach(exception => {
		if (!exception || typeof exception !== 'string') {
			return;
		}

		const lowerException = exception.toLowerCase();
		const lowerFormatted = formatted.toLowerCase();

		if (lowerFormatted.includes(lowerException)) {
			const regex = new RegExp(lowerException, 'gi');
			formatted = formatted.replace(regex, exception);
		}
	});

	return formatted;
}
